import { render } from "./RegistrationNPI.vue?vue&type=template&id=712c5956&scoped=true&ts=true"
import script from "./RegistrationNPI.vue?vue&type=script&lang=ts"
export * from "./RegistrationNPI.vue?vue&type=script&lang=ts"

import "./RegistrationNPI.vue?vue&type=style&index=0&id=712c5956&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712c5956"]])

export default __exports__